import i18next from 'i18next';
import { removeLocal, getLocal, LocalNameEnum } from '@/util/storage';

function bytesToBase64(text: string) {
  const bytes = new TextEncoder().encode(text);
  const binString = Array.from(bytes, byte => String.fromCodePoint(byte)).join('');
  return btoa(binString);
}

const TLT = (text: string | number, params?: Record<string, string>) => {
  const source = String(text).trim();
  const key = bytesToBase64(source);
  // 部分模块在启动语言包前就读取文案，保持原有原文兜底，避免渲染 undefined。
  if (!i18next.isInitialized) return source;
  // 动态文案使用固定词条和插值；词条未发布时，中文兜底也必须展开参数。
  return i18next.t(key, { ...params, defaultValue: source });
};

// TLT = translate language tools
window.TLT = TLT;

if (getLocal(LocalNameEnum.mulLangLocalTag) === 'showLangControllerTag') {
  removeLocal(LocalNameEnum.mulLangLocalTag);
  window.TLT = (text: string | number, params?: Record<string, string>) => {
    const nodes = TLT(text, params);
    // return `${nodes}$$${text}$$`
    return `$$&&${nodes}&&##${text}##$$`
  };
}
